import api from 'Application/api/api';

const getCrowdDeskSync = (signal, id) =>
	api.get(`/finances/sync/${id}`, {
		signal,
		timeout: 6000000,
	});

export default getCrowdDeskSync;
